import { Link } from "react-router-dom";

export const LinkBtn = ({ customClasses = "", route = "/", children }) => {
  return (
    <Link to={route} className={`${customClasses}`}>
      {children}
    </Link>
  );
};
